import React from "react";
import {Link} from "react-router-dom";
import {AddLangLink} from "../../../AdminPart/src/Constants";

function createDangerHTML(info) {
    if (info) {return {__html : info.replaceAll('&gt;','>').replaceAll('&lt;','<')}} else {return {__html : ''}}
}

function ToChangeButton (props) {
    let label = (props.Text ? JSON.parse(props.Text)[props.lang] : props.TextDefault);
    let labelPhone = (props.TextPhone ? JSON.parse(props.Text)[props.lang] : props.TextDefault);
            return (
                <Link to={AddLangLink()[props.lang]+ props.ssilka} style={{textDecoration: 'none'}}>
                    <div className={props.className} >
                    <div className="StandartNoPhone" dangerouslySetInnerHTML={createDangerHTML(label)}/>
                    <nobr  className="StandartPhone" dangerouslySetInnerHTML={createDangerHTML(labelPhone)}/>
                    </div>
                </Link>
            )
}

export default ToChangeButton
